
import {extend} from './zviz2/zviz/functions';
import state from './zviz2/zviz/state';

export let styleText = {
    fontFamily: '"Noto Sans", sans-serif',
    // fontSize: '11pt',
    fontSize: (ctrl) => ( (state.get('renderSize') == 'large')? '11pt': '9pt' ),
    lineHeight: '1.5em',
    color: '#230050'
};

export let styleWords = extend({
     fontSize: (ctrl) => ( (state.get('renderSize') == 'large')? '12pt': '10pt' )
}, styleText);

export let styleHeader2 = extend({
     fontSize: '12pt',
     lineHeight: '2em',
     borderBottom: '3px solid #fa3c4b',
     fontWeight: 'bold',
     margin: '15px 0px 8px 0px',
     fontFamily: '"Overpass", sans-serif'
}, styleText);

export let styleFilterHeader = extend({
    color: 'white',
    display: 'block',
    marginBottom: '5px',
    fontFamily: '"Overpass", sans-serif'
}, styleWords);